<template>
    <div class="d-flex flex-column min-vh-100">
        <div class="flex-grow-1 d-flex flex-column">
            <TheTopMenu :account-menu="accountMenu" :user="user" />
            <VerifyEmailBanner />
            <TheHeader :menu-data="menuData" />
            <div class="flex-grow-1">
                <div class="container h-100">
                    <div class="row justify-content-center my-lg-5">
                        <StudentProfileNavLinks />
                        <nuxt />
                    </div>
                </div>
            </div>
            <Footer :footer-links="footerLinks" />
        </div>
    </div>
</template>

<script>
import Base from './base';
import TheTopMenu from 'frontend-resources/components/Header/TheTopMenu';
import TheHeader from 'frontend-resources/components/Header/TheHeader';
import Footer from 'frontend-resources/components/Footer/Footer';
import StudentProfileNavLinks from '@/components/StudentProfileNavLinks';
import VerifyEmailBanner from '@/components/VerifyEmailBanner';

export default {
    components: { TheTopMenu, TheHeader, Footer, StudentProfileNavLinks, VerifyEmailBanner },
    extends: Base,
};
</script>
